import { roundData } from '../data';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { useGameListSocket } from '@/socket/gamelist/index';
import { oGameName2Api } from '@/common/js/gameAbout';

export const useStair = (
    musicControler = null,
    forHistoryDialog = false,
) => {
    const joinStateStore = useJoinStateStore();
    // state
    const initialState = {
        round: {
            ...roundData,
        },
        man: {
            position: {
                x: -2,
                y: 0,
            },
            isLeft: true,
            isAnimating: false,
            animation: '',
            isPopup: false, // 是否在投注详情中的弹出结果
            animationTime: 450 // 动画时间
        },
        currentStone: 4,
        betIslocked: false,
        winAmount: 0,
        isOpenResult: false,
        insertDelay: 200 // 数据插入延迟
    };
    const coefficients = reactive(initialState);

    // ↓ 楼层布局信息（稍后被赋值）
    const stairRows = reactive([...Array(13).keys()].map(()=>{
        return {length: 10, offset: 0};
    }));
    
    // ↓ 返现倍数列表（稍后被赋值）
    const stoneOptions = reactive({
        "1": stairRows.map(() => 1),
        "2": stairRows.map(() => 1),
        "3": stairRows.map(() => 1),
        "4": stairRows.map(() => 1),
    });
    
    // 当前的返现倍数列表 
    const aCurMultiArr = computed(() => {
        return stoneOptions[coefficients.currentStone];
    });

    // computed
    const cashAble = computed(() => {
        if (coefficients.round.status == 'cashout') return true;
        return coefficients.round.status === 'play' && coefficients.round.revealed.length > 0;
    });

    // methods
    const handleManPosition = (boardElement: HTMLElement) => {
        if (boardElement) {
            const boradWidth = boardElement.offsetWidth;
            const boardHeight = boardElement.offsetHeight;
            const currentRow = stairRows[coefficients.round.revealed.length - 1];
            const currentPosition =
                coefficients.round.revealed[coefficients.round.revealed.length - 1];
            const currentBoard = currentPosition + currentRow?.offset + 1;

            const stepWidth = boradWidth / 10;
            const positionX = stepWidth * currentBoard - stepWidth / 2;

            const positionXPercentage = (positionX / boradWidth) * 100;
            // 快速模式下不需要添加动画效果
            coefficients.man.animation = '';
            coefficients.man.position.y = (boardHeight / 13) * coefficients.round.revealed.length - 1;
            coefficients.man.position.x = positionXPercentage;
        }
    };
    const resetCoefficients = () => {
        coefficients.round = {
            ...roundData,
            revealed: [],
        };
        coefficients.man = {
            position: {
                x: -2,
                y: 0,
            },
            isLeft: true,
            isAnimating: false,
            animation: '',
            isPopup: false, // 是否在投注详情中的弹出结果
            animationTime: 450 // 动画时间
        };

        coefficients.betIslocked = false;
        coefficients.winAmount = 0;
    };
    const fnGetStairsConfig = ()=>{
        const { EMIT_GET_GAME_CONFIG } = useGameListSocket();
        EMIT_GET_GAME_CONFIG(
            {game: oGameName2Api.stairsGame},
            (oData)=>{
                if (!oData || oData.error) {
                    console.error('查询游戏配置失败', oData); 
                    return;
                }
                const {rows, coefficients} = oData.config as any; 
                Object.assign(stoneOptions, coefficients); 
                Object.assign(stairRows, deepCopy(rows).reverse()); 
                // console.log(`${oGameName2Api.stairsGame} 游戏配置`, deepCopy(stoneOptions), deepCopy(stairRows)); 
            }
        );
    }

    // 监听获取未完成的游戏数据
    watch(
        () => joinStateStore.lastRound,
        (newVal, oldVal) => {
            if (import.meta.server || forHistoryDialog) return;
            const toLoad = newVal && Object.keys(newVal).length && JSON.stringify(newVal)!== JSON.stringify(oldVal);
            if (!toLoad) return; 
            coefficients.round = {
                ...coefficients.round,
                ...newVal,
                ...newVal.state,
            } as any;

            coefficients.currentStone = newVal.state.count;
            const cb = () => {
                const boardElement = document.getElementById('board');
                if (boardElement) {
                    handleManPosition(boardElement);
                } else {
                    setTimeout(cb, 100);
                }
            };
            cb();
            showLastRoundLoadedInfo();
        },
        {
            deep: true,
            immediate: true,
        }
    );

    // ↓ 应用游戏配置 
    watch(
        () => joinStateStore.hasGameInfoLoaded,
        (bNewVal) => {
            if (import.meta.server || !bNewVal) return;
            const {rows, coefficients} = joinStateStore.config;
            // console.log(`${joinStateStore.gameName} 游戏配置已经加载：`, deepCopy(coefficients));
            Object.assign(stoneOptions, coefficients); 
            Object.assign(stairRows, deepCopy(rows)?.reverse()); 
        },
        {deep: true, immediate: true},
    );

    watch(
        () => coefficients.round.multi,
        (multi) => {
            if (Boolean(aCurMultiArr.value?.at) == false) {
                console.error('aCurMultiArr.value 数据异常');
                console.log('石头数量：', coefficients.currentStone); 
                console.log('倍数信息：', deepCopy(stoneOptions)); 
                return;
            }
            const won = multi && (
                multi > aCurMultiArr.value.at(-2) ||
                multi === aCurMultiArr.value.at(-1)
            );
            if (won && !coefficients.man.isPopup) {
                console.log('watch() 监测到登顶，倍数：', multi); 
                const sFiled = JSON.stringify(coefficients.round.field);
                setTimeout(() => {
                    coefficients.isOpenResult = true;
                }, coefficients.man.animationTime);
                setTimeout(() => {
                    if (sFiled == JSON.stringify(coefficients.round.field)){
                        resetCoefficients();
                    }else{
                        console.log('放弃清空舞台'); // 不清空，因为可能新开局了 
                    }
                }, 1200 + 1000); // 1200 是改之前的值，+ 后面是修改后追加的时间 
            }
        },
    );
    // ↓ 用于及时标记“游戏进行中” 的状态，以便在用户离开游戏时提示用户 
    watch(
        () => coefficients.round,
        (oNewRound) => {
            if (import.meta.server) return;
            // console.log('round.status --->', oNewRound.status || '无');
            const isGaming = ['play'].includes(oNewRound.status);
            joinStateStore.gameRunning = isGaming; 
        },
        {deep: true, immediate: true},
    );
    
    if (forHistoryDialog && import.meta.client) {
        fnGetStairsConfig();
    }
    return {
        coefficients,
        handleManPosition,
        cashAble,
        resetCoefficients,
        stoneOptions,
        stairRows,
    };
};
